// @flow

import { failure } from 'common/json/extract';
import type { JSONValue } from 'common/types';

export const decimal: JSONValue => number = (json: JSONValue) => {
  if (typeof json === 'number') {
    return json;
  } else if (typeof json === 'string') {
    return Number(json);
  }
  return failure(
    `Expecting decimal (number or string), got ${
      json === null ? 'null' : typeof json
    }`,
    () => Number(json)
  );
};
